import {
  AuthActions,
  AuthActionTypes,
} from '@app/auth/store/actions/auth.actions';
import { UserActions, UserActionTypes } from '../actions';
import {
  CompanyWorkData,
  PersonalWorkData,
} from '@app/shared/models/user.model';
import { TRole } from 'src/utils/declarations';

export interface State {
  id?: string;
  type?: string;
  personal?: {
    firstName?: string;
    lastName?: string;
    middleName?: string;
    phone?: string;
    email?: string;
    fullName?: string;
    user_id: number;
    filial_agency?: number | null;
  };
  roles?: TRole[];
  consfirmationEmail?: string;
  subscribeToNews?: boolean;
  workingData?: PersonalWorkData | CompanyWorkData;
  rolesLoaded: boolean;
}

export const initialState: State = {
  rolesLoaded: false,
};

export function reducer(
  state: any = initialState,
  action: AuthActions | UserActions
): State {
  switch (action.type) {
    case AuthActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        id: action.payload.user.id,
        personal: {
          firstName: action.payload.user.profile.personal.firstName,
          lastName: action.payload.user.profile.personal.lastName,
          middleName: action.payload.user.profile.personal.middleName,
          phone: action.payload.user.phone,
          email: action.payload.user.email,
          filial_agency: action.payload.user.filial_agency
            ? +action.payload.user.filial_agency
            : null,
          user_id: action.payload.user.profile.user_id,
        },
        type: action.payload.user.profile.type,
        workingData: action.payload.user.profile.workingData,
        roles: action.payload.user.role,
        subscribeToNews: action.payload.user.profile.subscribeToNews,
        rolesLoaded: true,
      };
    }

    case AuthActionTypes.LOGOUT_SUCCESS: {
      return initialState;
    }

    case AuthActionTypes.LOGOUT_CLIENT_SUCCESS: {
      return state;
    }

    case AuthActionTypes.REGISTER_SUCCESS: {
      return {
        ...state,
        id: action.payload.id,
        personal: {
          fullName: action.payload.name,
          email: action.payload.email,
          phone: action.payload?.phone?.toString(),
        },
        roles: action.payload.roles,
        rolesLoaded: true,
      };
    }

    case UserActionTypes.GET_CURRENT_USER_SUCCESS: {
      return {
        ...state,
        id: action.payload.id,
        personal: {
          firstName: action.payload.personal.firstName,
          lastName: action.payload.personal.lastName,
          middleName: action.payload.personal.middleName,
          phone: action.payload.personal.phone,
          filial_agency: action.payload.filial_id,
          email: action.payload.personal.email,
        },
        user_id: action.payload.user_id,
        type: action.payload.type,
        subscribeToNews: action.payload.subscribeToNews,
        workingData: action.payload.workingData,
      };
    }

    case UserActionTypes.UPDATE_SUCCESS: {
      return {
        ...state,
        id: action.payload.id,
        type: action.payload.type,
        workingData: action.payload.workingData,
        subscribeToNews: action.payload.subscribeToNews,
      };
    }

    case UserActionTypes.UPDATE_PERSONAL_SUCCESS: {
      return {
        ...state,
        personal: action.payload,
      };
    }

    case AuthActionTypes.RECOVER_PASSWORD: {
      return {
        ...state,
        consfirmationEmail: action.payload.email,
      };
    }

    case AuthActionTypes.UPDATE_PASSWORD_SUCCESS: {
      return {
        ...state,
        consfirmationEmail: null,
      };
    }

    case AuthActionTypes.GET_ROLES_SUCCESS: {
      return {
        ...state,
        roles: action.payload,
        rolesLoaded: true,
      };
    }

    default: {
      return state;
    }
  }
}

export const getUser = (state: State) => state;
export const getUserRoles = (state: State) => state?.roles;
export const getUserId = (state: State) => state?.id;
export const getConfirmationEmail = (state: State) => state?.consfirmationEmail;
export const getRolesLoaded = (state: State) => state.rolesLoaded;
